import React from 'react';
import PropTypes from 'prop-types';
import useForm from '@afosto/utils-react/validation/useForm';
import useRegisterInput from '@afosto/app-components-react/Form/useRegisterInput';
import CalculationItemFormSection from './CalculationItemsFormSection';
import Form from '@afosto/app-components-react/Form';
import LoadingWrapper from '@afosto/components-react/LoadingWrapper';
import validationSchema from './validations';

const CalculationInvoiceForm = ({ onSubmit, onCancel, items }) => {
  const form = useForm({
    validationSchema,
    defaultValues: {
      items,
    },
    onSubmit,
    onCancel,
  });

  useRegisterInput('items', true, form);

  return (
    <LoadingWrapper isLoading={form?.isSubmitting}>
      <Form form={form}>
        <CalculationItemFormSection />
      </Form>
    </LoadingWrapper>
  );
};

CalculationInvoiceForm.propTypes = {
  items: PropTypes.array,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
};

CalculationInvoiceForm.defaultProps = {
  items: [],
  onCancel: undefined,
  onSubmit: undefined,
};

export default CalculationInvoiceForm;
